import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { XlsxImportDevicePayload } from 'api/actions/xlsx-import-device/xlsx-import-device-payload';
import { XlsxImportDevicePathParameters } from 'api/actions/xlsx-import-device/xlsx-import-device-path-parameters';
import { XlsxImportDeviceResponse } from 'api/actions/xlsx-import-device/xlsx-import-device-response';

type XlsxImportDeviceQueryParameters = Record<string, any>;

/**
 * The path of the XlsxImportDevice action.
 */
export const xlsxImportDeviceActionPath = new SweetPath<keyof XlsxImportDevicePathParameters>(
  '/api/xlsx/import-device',
  { path: '{param}' }
);

/**
 * Creates a contextualized XlsxImportDevice actions.
 */
export default function createXlsxImportDeviceAction(axios: AxiosInstance) {
  return function xlsxImportDeviceAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: XlsxImportDeviceQueryParameters;
    payload: XlsxImportDevicePayload;
  }) {
    const path = xlsxImportDeviceActionPath.original;

    return axios.request<XlsxImportDeviceResponse, XlsxImportDeviceResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
